import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Loader2 } from "lucide-react";

const VOCI = [["bonifico", "Bonifico"], ["pos", "POS"], ["contanti", "Contanti"], ["assegno", "Assegno"], ["altro", "Altro"], ["none", "Non specificato"]];
const fmt = (n) => `${(n || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
const MESI = ["", "gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"];

export const PagatoPerMetodo = ({ tab, mese, giorno, refreshKey, selectedIds = [] }) => {
  const selKey = selectedIds.join(",");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const p = selKey ? [`ids=${selKey}`] : [];
    if (!selKey && (tab === "acquisto" || tab === "vendita")) p.push(`tipo=${tab}`);
    if (!selKey && tab === "da_pagare") p.push("stato=da_pagare");
    if (giorno) p.push(`giorno=${giorno}`);
    else if (mese) p.push(`mese=${mese}`);
    setLoading(true);
    const t = setTimeout(() => {
      api.get(`/fatture/riepilogo-metodi?${p.join("&")}`)
        .then(({ data }) => setData(data))
        .catch(() => setData(null))
        .finally(() => setLoading(false));
    }, 150);
    return () => clearTimeout(t);
  }, [tab, mese, giorno, refreshKey, selKey]);

  const periodo = giorno ? giorno : mese ? MESI[mese] : "tutto il periodo";
  return (
    <Card className="card-elevated" data-testid="pagato-per-metodo">
      <CardContent className="p-5">
        <div className="flex items-center justify-between">
          <div className="text-[10px] uppercase tracking-widest text-muted-foreground">Pagato per metodo · {periodo}{selectedIds.length > 0 ? ` · selezione (${selectedIds.length})` : ""}</div>
          {loading && <Loader2 className="h-3 w-3 animate-spin text-muted-foreground" />}
        </div>
        <div className="text-2xl font-extrabold" data-testid="pagato-metodo-totale">{fmt(data?.totale)}</div>
        {data?.ritenute > 0 && (
          <div className="text-[11px] text-muted-foreground" data-testid="pagato-metodo-ritenute">lordo · di cui ritenute {fmt(data.ritenute)} · accreditato {fmt(data.netto)}</div>
        )}
        <div className="mt-2 grid grid-cols-2 xl:grid-cols-1 gap-x-3 gap-y-0.5 text-xs">
          {VOCI.map(([k, l]) => (
            <div key={k} className="flex justify-between gap-2" data-testid={`pagato-metodo-${k}`}>
              <span className="text-muted-foreground">{l}</span>
              <span className="font-semibold tabular-nums">{fmt(data?.metodi?.[k])}</span>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
